var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-spots-manual"},[_c(_vm.content.nzSettingLayout === 'List' ? 'spots-list' : 'spots-carousel',{tag:"component",attrs:{"spots":_vm.content.spots,"headline":_vm.content.headline,"image":_vm.content.image,"image-alt-text":_vm.content.imageAltText,"is-aligned-right":_vm.content.nzSettingLayout === 'Carousel - Image right'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }